import * as React from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
    root: {
        flex: 1,
    },
    cost: {
        marginRight: '1em',
        color: theme.palette.text.primary,
    },
}));

const processSignups = (signups) => 
    Object.entries(signups).reduce((acc, item) => {
        const [key, val] = item
        let n = val.map(i => {i.date = key; return i})
        acc.push(...n)
        return acc
    }, [])


const SignupsList = ({ signups = [] }) => {
    const classes = useStyles();
    return (
        <Card className={classes.root}>
            <CardHeader title="30-day Signups Data" />
            <List dense={true}>
                {processSignups(signups).reverse().map(record => (
                    <ListItem
                        key={record.aid}
                        button
                        component={Link}
                        to={`/accounts/${record.aid}`}
                    >
                        {/* <ListItemAvatar>
                            {customers[record.customer_id] ? (
                                <Avatar
                                    src={`${
                                        customers[record.customer_id].avatar
                                    }?size=32x32`}
                                />
                            ) : (
                                <Avatar />
                            )}
                        </ListItemAvatar> */}
                        <ListItemText
                            primary={record.nm}
                            secondary={`${new Date(record.date).toLocaleDateString()}, ${record.em}`}
                        />
                        <ListItemSecondaryAction>
                            <span className={classes.cost}>
                                {record.cny}
                            </span>
                        </ListItemSecondaryAction>
                    </ListItem>
                ))}
            </List>
        </Card>
    );
};

export default SignupsList;
